import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { CsCalcPopupComponent } from '../cs-calc-popup/cs-calc-popup.component';

@Component({
  selector: 'app-edit-cs-calc',
  templateUrl: './edit-cs-calc.component.html',
  styleUrls: ['./edit-cs-calc.component.css']
})
export class EditCsCalcComponent implements ICellRendererAngularComp {

  public gridApi: any;
  public params: any;
  isEditVisible: any;
  countryCode;
  totalBK: any;
  crp: any;
  margin: any;
  bk: any;
  scenario: any;
  displayValue: string = '';

  @Output() opened = new EventEmitter<void>();

  constructor(
    public dialog: MatDialog,
    private localStorageService: LocalStorageService,
  ) { }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.gridApi = params.api;
    this.countryCode = this.localStorageService.get('countryCode');

    if (this.params.data.Description == "Price") {
      this.isEditVisible = this.params.data.IsEditable;
    }
    else {
      this.isEditVisible = false;
    }

    const value = params.value;
    if (value !== null && value !== undefined && !isNaN(Number(value))) {
      this.displayValue = new Intl.NumberFormat(this.countryCode)
        .format(Number(parseFloat(value).toFixed(2)));
    }
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  editData(params: any) {
    if (this.params.column.colId == "TargetScenario.TargetCost.PerSystem") {
      this.scenario = this.gridApi.getRowNode(0).data.TargetScenario.TargetCost.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.TargetScenario.TargetCost.PerSystem;
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.TargetScenario.TargetCost.PerSystem;
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.TargetScenario.TargetCost.PerSystem;
      this.totalBK = this.params.getTotalBK ? this.params.getTotalBK() : 0;
    }
    if(this.params.column.colId == "TargetScenario.Forecast.PerSystem"){
      this.scenario = this.gridApi.getRowNode(0).data.TargetScenario.Forecast.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.TargetScenario.Forecast.PerSystem
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.TargetScenario.Forecast.PerSystem
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.TargetScenario.Forecast.PerSystem;
      this.totalBK = this.params.getTotalBK ? this.params.getTotalBK() : 0;
    }
    if (this.params.column.colId == "OptionA.TargetCost.PerSystem") {
      this.scenario = this.gridApi.getRowNode(0).data.OptionA.TargetCost.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.OptionA.TargetCost.PerSystem;
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.OptionA.TargetCost.PerSystem;
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.OptionA.TargetCost.PerSystem;
      this.totalBK = this.params.getTotalBK ? this.params.getTotalBK() : 0;
    }
    if(this.params.column.colId == "OptionA.Forecast.PerSystem"){
      this.scenario = this.gridApi.getRowNode(0).data.OptionA.Forecast.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.OptionA.Forecast.PerSystem
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.OptionA.Forecast.PerSystem
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.OptionA.Forecast.PerSystem;
      this.totalBK = this.params.getTotalBK ? this.params.getTotalBK() : 0;
    }
    if (this.params.column.colId == "OptionB.TargetCost.PerSystem") {
      this.scenario = this.gridApi.getRowNode(0).data.OptionB.TargetCost.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.OptionB.TargetCost.PerSystem;
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.OptionB.TargetCost.PerSystem;
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.OptionB.TargetCost.PerSystem;
      this.totalBK = this.params.getTotalBK ? this.params.getTotalBK() : 0;
    }
    if(this.params.column.colId == "OptionB.Forecast.PerSystem"){
      this.scenario = this.gridApi.getRowNode(0).data.OptionB.Forecast.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.OptionB.Forecast.PerSystem
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.OptionB.Forecast.PerSystem
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.OptionB.Forecast.PerSystem;
      this.totalBK = this.params.getTotalBK ? this.params.getTotalBK() : 0;
    }
    if (this.params.column.colId == "OptionC.TargetCost.PerSystem") {
      this.scenario = this.gridApi.getRowNode(0).data.OptionC.TargetCost.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.OptionC.TargetCost.PerSystem;
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.OptionC.TargetCost.PerSystem;
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.OptionC.TargetCost.PerSystem;
      this.totalBK = this.params.getTotalBK ? this.params.getTotalBK() : 0;
    }
    if(this.params.column.colId == "OptionC.Forecast.PerSystem"){
      this.scenario = this.gridApi.getRowNode(0).data.OptionC.Forecast.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.OptionC.Forecast.PerSystem
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.OptionC.Forecast.PerSystem
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.OptionC.Forecast.PerSystem;
      this.totalBK = this.params.getTotalBK ? this.params.getTotalBK() : 0;
    }


    let dialogRef = this.dialog.open(CsCalcPopupComponent, {
      height: '40%',
      width: '60%',
      panelClass: 'kmat-dialog-container',
      data: {
        scenario: this.scenario,
        crp: this.crp,
        margin: this.margin,
        bk: this.bk,
        totalBK: this.totalBK
      }
    })

    if (this.params.onOpened) {
      this.params.onOpened();
    }

    dialogRef.afterClosed().subscribe(result => {
      if (result && result != "" && result != null) {
        if (this.params.column.colId == "TargetScenario.TargetCost.PerSystem") {
          this.gridApi.getRowNode(0).data.TargetScenario.TargetCost.PerSystem = result.Scenario
          this.gridApi.getDisplayedRowAtIndex(0).data.TargetScenario.TargetCost.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.TargetScenario.TargetCost.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.TargetScenario.TargetCost.PerSystem = result.BK;
        }
        if(this.params.column.colId == "TargetScenario.Forecast.PerSystem"){
          this.gridApi.getRowNode(0).data.TargetScenario.Forecast.PerSystem = result.Scenario
          this.gridApi.getDisplayedRowAtIndex(0).data.TargetScenario.Forecast.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.TargetScenario.Forecast.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.TargetScenario.Forecast.PerSystem = result.BK;
        }
        if (this.params.column.colId == "OptionA.TargetCost.PerSystem") {
          this.gridApi.getRowNode(0).data.OptionA.TargetCost.PerSystem = result.Scenario
          this.gridApi.getDisplayedRowAtIndex(0).data.OptionA.TargetCost.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.OptionA.TargetCost.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.OptionA.TargetCost.PerSystem = result.BK;
        }
        if(this.params.column.colId == "OptionA.Forecast.PerSystem"){
          this.gridApi.getRowNode(0).data.OptionA.Forecast.PerSystem = result.Scenario
          this.gridApi.getDisplayedRowAtIndex(0).data.OptionA.Forecast.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.OptionA.Forecast.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.OptionA.Forecast.PerSystem = result.BK;
        }
        if (this.params.column.colId == "OptionB.TargetCost.PerSystem") {
          this.gridApi.getRowNode(0).data.OptionB.TargetCost.PerSystem = result.Scenario
          this.gridApi.getDisplayedRowAtIndex(0).data.OptionB.TargetCost.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.OptionB.TargetCost.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.OptionB.TargetCost.PerSystem = result.BK;
        }
        if(this.params.column.colId == "OptionB.Forecast.PerSystem"){
          this.gridApi.getRowNode(0).data.OptionB.Forecast.PerSystem = result.Scenario
          this.gridApi.getDisplayedRowAtIndex(0).data.OptionB.Forecast.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.OptionB.Forecast.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.OptionB.Forecast.PerSystem = result.BK;
        }
        if (this.params.column.colId == "OptionC.TargetCost.PerSystem") {
          this.gridApi.getRowNode(0).data.OptionC.TargetCost.PerSystem = result.Scenario
          this.gridApi.getDisplayedRowAtIndex(0).data.OptionC.TargetCost.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.OptionC.TargetCost.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.OptionC.TargetCost.PerSystem = result.BK;
        }
        if(this.params.column.colId == "OptionC.Forecast.PerSystem"){
          this.gridApi.getRowNode(0).data.OptionC.Forecast.PerSystem = result.Scenario
          this.gridApi.getDisplayedRowAtIndex(0).data.OptionC.Forecast.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.OptionC.Forecast.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.OptionC.Forecast.PerSystem = result.BK;
        }

        this.gridApi.refreshCells({ force: true });
        this.gridApi.redrawRows();

        if (this.params.onPriceSaved) {
          this.params.onPriceSaved();
        }
      }
    });
  }

}
